export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  bloodGroupCreatedById: number;
  bloodGroupId: number;
  bloodGroupName: string;
  bloodGroupShortName: string;
  bloodGroupStatus: number;
  bloodGroupClinicId: number;
  bloodGroupCreatedByDate: string;
};

export type MasterDataType = {
  bloodGroupId: number;
  bloodGroupName: string;
  bloodGroupShortName: string;
  bloodGroupStatus: number;
  bloodGroupClinicId: number;
  bloodGroupCreatedByDate: string;
  createdById: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  bloodGroupName: string;
  bloodGroupShortName: string;
  bloodGroupStatus: number;
};

export const initialFormData: MasterFormDataType = {
  bloodGroupName: "",
  bloodGroupShortName: "",
  bloodGroupStatus: 1,
};
